export const setVasItem = ({ selectedItemId, isFrmListing }) => {
    return {
        type: 'VAS_SHEET_TOGGLE',
        data: {
            selectedItemId,
            isFrmListing: !!isFrmListing
        }
    };
};
